import { render, staticRenderFns } from "./DetailsAttachments.vue?vue&type=template&id=2776039a&"
import script from "./DetailsAttachments.vue?vue&type=script&lang=js&"
export * from "./DetailsAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports